// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___5d52e7aff6b00b7a4e1","cls2":"SimplePaperPodcast-cls2__afc47bccd1f0be7a0095 SimplePaperPodcast-cls1___5d52e7aff6b00b7a4e1"};